// extracted by mini-css-extract-plugin
export default {"pdfWrapper":"PartsCaraousel_pdfWrapper__UFiqF","pdfPageWrapper":"PartsCaraousel_pdfPageWrapper__xCx+l"};